import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const regionsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createRegion',
        popover: {
          title: 'Create New Region',
          description:
            'Click here to create a new region. Regions help organize and manage your infrastructure across different geographical locations.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.attachCompany',
        popover: {
          title: 'Attach Company to Region',
          description:
            'Use this feature to associate a company with this region, ensuring that resources and services are managed within the correct geographical scope.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editRegion',
        popover: {
          title: 'Edit Region',
          description:
            'Modify the settings of an existing region to reflect changes in your infrastructure needs or geographical focus.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteRegion',
        popover: {
          title: 'Delete Region',
          description:
            'Remove this region from your infrastructure. Ensure that it is no longer needed, as this action is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.regionMainTableData',
        popover: {
          title: 'Regions Overview Table',
          description:
            'This table provides an overview of all regions, allowing you to view, edit, and manage regions efficiently.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default regionsDriverObj;
